import React from 'react';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import {Row, Col} from 'react-flexbox-grid/lib';
import { connect } from 'react-redux';
import {Card, CardHeader, CardMedia, CardText} from 'material-ui/Card';
import {List, ListItem} from 'material-ui/List';
import Divider from 'material-ui/Divider';
import ContentRight from 'material-ui/svg-icons/hardware/keyboard-arrow-right';

import NotAvailable from 'components/notAvailable/NotAvailable';
import styles from './styles/BOMDataStyles';
import SpinnerLoaderWithText from 'components/loaders/SpinnerLoaderWithText';

class BOMData extends React.Component {
    render() {
        console.info("bom data rendered");

        const {translate, bom, isBomSearching, bomList, isBomListSearching} = this.props;

        return (
            <div style={styles.mainDataRow}>
                {
                    isBomSearching || isBomListSearching ? <SpinnerLoaderWithText />
                    :
                    <Row>
                        <Col xs={12} sm={12} md={6} lg={4} >
                            <Card initiallyExpanded={true} >
                                <CardHeader
                                    title={translate('DentDetailsForm.predictiveCarDamage')}
                                />
                                {
                                    bom ?
                                    <div>
                                        <CardText>
                                            {translate('DentDetailsForm.predictiveCarDamageCaption')}
                                        </CardText>
                                        <CardMedia expandable={true} >
                                            <img src={`data:image/jpeg;base64,${bom}`} alt="Predictive " />
                                        </CardMedia>
                                    </div>

                                 :
                                    <CardText expandable={true} >
                                        <NotAvailable />
                                    </CardText>
                                }
                            </Card>
                        </Col>
                        <Col xs={12} sm={12} md={6} lg={8} >
                            <Card initiallyExpanded={true}>
                                <CardHeader
                                    title={translate('DentDetailsForm.materialsBill')}
                                />
                                <CardText expandable={true} >
                                {
                                    !bomList ? <NotAvailable /> :
                                        <List>
                                            {
                                                bomList.map(bomItem =>
                                                    <div key={bomItem.id}>
                                                        <Divider/>
                                                        <ListItem
                                                            key={bomItem.id}
                                                            leftIcon={<ContentRight />}
                                                            primaryText={
                                                                <span>{bomItem.bodyPart}</span>
                                                            }
                                                        />
                                                    </div>
                                                )
                                            }
                                        </List>
                                }
                                </CardText>
                            </Card>
                        </Col>
                    </Row>
                }
            </div>
        );
    }
}

BOMData.propTypes = {
    //x: PropTypes.object,
    //x: PropTypes.func,
    //x: PropTypes.bool,
    //x: PropTypes.array.isRequired,
    //x: PropTypes.object.isRequired
}

function mapStateToProps(state, ownProps){
    return {
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code,
        bom: state.crashboxxBom.binaries,
        isBomSearching: state.crashboxxBom.isSearching,
        bomList: state.icnBomList.list,
        isBomListSearching: state.crashboxxBom.isBomListSearching,
    }
}
export default connect(mapStateToProps, null)(BOMData);



// WEBPACK FOOTER //
// ./src/components/detailsPage/BOMData.js